import { render, staticRenderFns } from "./TaxManagement.vue?vue&type=template&id=7e7595f6&scoped=true&"
import script from "./TaxManagement.vue?vue&type=script&lang=js&"
export * from "./TaxManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e7595f6",
  null
  
)

export default component.exports